import { useEffect } from 'react';
import { useSnackbar } from 'design-system';
// import { componentsRoutes } from './components';
import { Navigate, useRoutes } from 'react-router-dom';

import { useAuthContext } from 'src/auth/hooks';
import { EventTopic } from 'src/services/pubSub';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { ApiError, HttpStatus } from 'src/services/httpClient';

// import { HomePage, mainRoutes } from './main';
import { mainRoutes } from './main';
// import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

export default function Router() {
  const { enqueueSnackbar } = useSnackbar();
  const { logout } = useAuthContext();

  useEffect(() => {
    const apiErrorSubscriber = (topic: string, data: ApiError) => {
      if (data.status === HttpStatus.Unauthorized) {
        window.alert(data?.message ?? '登录信息失效！请重新登录');
        logout();
      }

      // 获取当前路径
      const currentPath = window.location.pathname;

      // 定义不需要显示snackbar的特定页面路径
      const excludedPaths = [
        '/dashboard/objectivesManagement/business-plan-report',
        '/dashboard/analysis/analysis-report/list',
        '/dashboard/objectivesManagement/kpi-report',
        '/dashboard/systemManagement/assessmentDimension',
      ];

      // 检查当前路径是否在排除列表中
      const isExcludedPath = excludedPaths.some((path) => currentPath.includes(path));

      // 检查是否是考核维度重复名字的错误
      const isDuplicateAssessmentDimensionError = data?.status === 422;

      // 除了excludedPaths中的页面和考核维度重复错误外，所有页面都显示snackbar
      const shouldShowSnackbar = !isExcludedPath && !isDuplicateAssessmentDimensionError;

      if (shouldShowSnackbar) {
        enqueueSnackbar(data.message || '未知错误', { variant: 'error' });
      }
    };
    const token = PubSub.subscribe(EventTopic.API_ERRORS, apiErrorSubscriber);
    return () => {
      PubSub.unsubscribe(token);
    };
  }, [logout]);
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,
    // Components routes
    // ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}
